import { render, staticRenderFns } from "./levelsPage.vue?vue&type=template&id=9d07f446&scoped=true"
import script from "./levelsPage.vue?vue&type=script&lang=ts"
export * from "./levelsPage.vue?vue&type=script&lang=ts"
import style0 from "./levelsPage.vue?vue&type=style&index=0&id=9d07f446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d07f446",
  null
  
)

export default component.exports